// extracted by mini-css-extract-plugin
module.exports = {"graphic":"FAQGeneral_graphic_2WhpZ"};